// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.hamburger-menu-internal-layout {
  width: 90%;
  flex:1 1;
  background-color: rgba(31, 27, 250, 0.103);
  margin-left: auto;
  margin-right:auto;
  /* margin-left: 5%;
  margin-right: 5%; */
  margin-bottom: 5px;
  padding-left:5px;
  padding-right:5px;
  padding-top: 10px;
  border-radius: 10px;
}


.hamburger-menu-button-container {
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1vh;

  /* background-color: ghostwhite; */
}

.logout-button {
  display: flex;
  width: 95%;
  background-color: rgba(39, 39, 38, 0.219);
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 5%;
}

.hamburger-menu-login-button {
  display: flex;
  width: 95%;
  background-color: rgba(42, 189, 42, 0.219);
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 5%;
}

.logout-button:hover{
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/HamburgerMenu.css"],"names":[],"mappings":";;AAEA;EACE,UAAU;EACV,QAAM;EACN,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;EACjB;qBACmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;EAElB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yCAAyC;EACzC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":["\n\n.hamburger-menu-internal-layout {\n  width: 90%;\n  flex:1;\n  background-color: rgba(31, 27, 250, 0.103);\n  margin-left: auto;\n  margin-right:auto;\n  /* margin-left: 5%;\n  margin-right: 5%; */\n  margin-bottom: 5px;\n  padding-left:5px;\n  padding-right:5px;\n  padding-top: 10px;\n  border-radius: 10px;\n}\n\n\n.hamburger-menu-button-container {\n  width: 100%;\n  height: 10%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1vh;\n\n  /* background-color: ghostwhite; */\n}\n\n.logout-button {\n  display: flex;\n  width: 95%;\n  background-color: rgba(39, 39, 38, 0.219);\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  border-radius: 5%;\n}\n\n.hamburger-menu-login-button {\n  display: flex;\n  width: 95%;\n  background-color: rgba(42, 189, 42, 0.219);\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  border-radius: 5%;\n}\n\n.logout-button:hover{\n  opacity: 0.8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
